import { render, staticRenderFns } from "./CrmSettings.vue?vue&type=template&id=afebd48e"
import script from "./CrmSettings.vue?vue&type=script&lang=js"
export * from "./CrmSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports